import type { AxiosResponse } from 'axios';
import { ENDPOINTS } from '@/constants/endpoints';
import { axiosInstance } from '@/services/axios.service';

export interface FrontendConfigResponse {
	HelpUrl: string;
	// Beta flag for the self-service card-management UI (Add Payment Method).
	EnableCardManagement: boolean;
}

export const getFrontendConfig = async (): Promise<AxiosResponse<FrontendConfigResponse>> => {
	return await axiosInstance.get<FrontendConfigResponse>(
		ENDPOINTS['/api/Config/GetFrontendConfig']
	);
};
